import React from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  List,
  ListItem,
  ListItemText,
  Typography,
  Box,
} from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

export const CardLayout3 = ({
  content,
  register_page,
  page,
  setPage,
  open,
  setOpen,
  btn_label,
  default_btn_label,
  lastpage,
}) => {
  const toggleDialog1 = () => {
    setOpen(!open);
  };

  return (
    <>
      {!register_page && (
        <List>
          <ListItem
            button
            onClick={toggleDialog1}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "16px",
              border: "1px solid #ccc",
              borderRadius: "8px",
              marginBottom: "8px",
            }}
          >
            <ListItemText primary={btn_label} />
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Typography variant="body2" sx={{ marginRight: "8px" }}>
                {default_btn_label}
              </Typography>
              <ChevronRightIcon />
            </Box>
          </ListItem>
        </List>
      )}
      <Dialog open={open} onClose={toggleDialog1}>
        <DialogTitle sx={{ textAlign: "center" }}>{btn_label}</DialogTitle>
        <DialogContent>{content}</DialogContent>
        <DialogActions>
          <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
            {register_page && !lastpage && (
              <Button
                variant="contained"
                onClick={() => {
                  setPage(page + 1);
                }}
              >
                NEXT
              </Button>
            )}
            {!register_page && !lastpage && (
              <Button
                variant="contained"
                onClick={() => console.log("saving")}
              >
                SAVE
              </Button>
            )}
          </Box>
          <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
            {register_page ? (
              <Button
                variant="text"
                onClick={() =>
                  page > 0 ? setPage(page - 1) : console.log("this is page 1")
                }
              >
                BACK
              </Button>
            ) : (
              <Button variant="text" onClick={() => setOpen(false)}>
                CANCEL
              </Button>
            )}
          </Box>
        </DialogActions>
      </Dialog>
    </>
  );
};